import React from 'react';

const ModalHeader = ({ title }) => {
  return (
    <div className="modal-header">
      <h2 className="modal-header__title">{title}</h2>
    </div>
  );
};

export default ModalHeader;
